// components/HeroSection/HeroSection.jsx
import React from "react";
import { Rocket, Mail } from "lucide-react";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-background-shapes">
        <div className="hero-shape hero-shape-blue animate-blob"></div>
        <div className="hero-shape hero-shape-purple animate-blob animation-delay-2000"></div>
        <div className="hero-shape hero-shape-pink animate-blob animation-delay-4000"></div>
      </div>

      <div className="hero-content">
        <h1 className="hero-title font-heading animate-fade-in-up">
          Innovate. <span className="hero-title-highlight">Transform.</span>{" "}
          <span className="hero-succeed">Succeed.</span>
        </h1>
        <p className="hero-subtitle font-body animate-fade-in delay-500">
          Your trusted partner for cutting-edge IT solutions that drive growth
          and efficiency.
        </p>
        <div className="hero-buttons-container animate-fade-in delay-1000">
          <a
            href="#services"
            className="hero-button hero-button-primary font-body"
          >
            <Rocket className="icon-small icon-margin-right" /> Our Services
          </a>
          <a
            href="#contact"
            className="hero-button hero-button-secondary font-body"
          >
            <Mail className="icon-small icon-margin-right" /> Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
